import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const AddAppointment = async (e) => {
  /**
   * input: appointment object
   * output: null
   * description: create appointment / appointment document
   */
  try {
    const AppointmentsCollection = await collection(db, "appointments");

    const data = HelperForMetaData({
      ...e,
      bid: getLocalStorageItem("bid"),
    });
    const result = await addDoc(AppointmentsCollection, data);
    return result;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default AddAppointment;
